// extracted by mini-css-extract-plugin
var _1 = "w_Fzq";
var _2 = "rGhhJ";
var _3 = "A1PU2";
export { _1 as "base", _2 as "buttons", _3 as "main" }
